























































































































































































































import {
  Prop,
  Vue,
  Component,
  Watch,
} from "@/shared/vuepack";
import { Location } from "vue-router";
import { Validator } from "vee-validate";
import ScheduleFrequencySelect from "@/shared/components/ui/ScheduleFrequencySelect.vue";
import {
  TransferSchedule,
  RecurringSchedule,
  TransferScheduleType,
  TransferScheduleStatus,
  TransferScheduleWeekDay,
  TransferScheduleMonthBoundary,
  FundingOption,
  TransferScheduleMonthlyByDayDetails,
  TransferScheduleOneTimeDetails,
  LinkedBankAccountUseStatus,
} from "@/shared/types";
import moment from "moment-timezone";
import _ from "lodash";
import ContributionConfirmationModal from "@/shared/components/contributionsV3/ContributionConfirmationModal.vue";
import ContributionsGraphWidget from "@/shared/components/contribution/ContributionsGraphWidget.vue";
import ContributionsDonutChart from "@/employee/components/contributionsV2/ContributionsDonutChart.vue";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";

import { ConfirmContribution, Contribution, LinkedAccountsSettings, OnboardingContributionScheduledMessage } from "@/employee/route-names";
import { usePersonalContributionSchedulesStore } from "@/shared/store/personalContributionSchedules";
import { useUserStore } from "@/shared/store/user";
import { useNotifierStore } from "@/shared/store/notifier";
import { useHsaTotalStore } from "@/shared/store/hsaTotal";
import { useBankAccountStore } from "@/employee/store/bankAccount";
import { useHsaLimitStore } from "@/shared/store/hsalimit";
import { useHsaStore } from "@/shared/store/hsa";
import { useContributionStore } from "@/shared/store/contribution";
import { formatDateString, formatMMMDateString } from "@/shared/dateString";
import { useBankHolidayStore } from "@/employer/store/bankHoliday";
import { isBusinessDay, addBusinessDays } from "@/shared/businessDayUtil";
import { useHsaContributionSummary } from "@/shared/store/hsaContributionSummary";
import * as transferScheduleUtility from "@/employee/Utilities/TransferScheduleUtility";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";
import { useHsabAccountsStore } from "@/employee/store/hsabAccounts";
import { useEmployerBankSettingsStore } from "@/shared/store/employerBankSettings";

@Component({
  components: {
    ScheduleFrequencySelect,
    ContributionsGraphWidget,
    ContributionsDonutChart,
    GenericLoadingSpinner,
    ContributionConfirmationModal
  }
})
export default class ContributionsEdit extends Vue {
  $validator: Validator;

  personalContributionScheduleStore = usePersonalContributionSchedulesStore();
  notifierStore = useNotifierStore();
  userStore = useUserStore();
  hsaTotalStore = useHsaTotalStore();
  contributionStore = useContributionStore();
  bankAccountStore = useBankAccountStore();
  bankHolidayStore = useBankHolidayStore();
  hsaLimitStore = useHsaLimitStore();
  hsaStore = useHsaStore();
  hsaContributionSummary = useHsaContributionSummary();
  featureFlagStore = useFeatureFlagStore();
  hsabAccountsStore = useHsabAccountsStore();
  employerBankSettings = useEmployerBankSettingsStore();
  LinkedAccountsSettings = LinkedAccountsSettings;

  @Prop()
  id: number;

  @Prop()
  value: TransferSchedule;

  @Prop()
  routeToConfirmation: (schedule: TransferSchedule, isUpdate: boolean) => Location;

  @Prop()
  defaultRecurring: boolean;

  @Prop()
  defaultPriorYear: boolean;

  @Prop()
  isOnboarding: boolean;

  isSubmitting = false;

  description = "";
  formModel: TransferSchedule = null;
  priorYear: number;
  forecastYear: number;

  oldScheduleType: TransferScheduleType = null;

  confirmModalVisible = false;
  debouncedGetProposedScheduleCalendars = _.debounce(args =>
    this.personalContributionScheduleStore.getProposedPersonalContributionScheduleCalendars(args), 250);

  intervalId = 0;
  currentHours = 0;

  constructor () {
    super();
    this.forecastYear = this.activePayrollYear;
    this.priorYear = this.activePayrollYear - 1;
  }

  get forecastYearHsaLimit () {
    return this.hsaContributionSummary.hsaLimit(this.forecastYear);
  }

  get projectedAnnualEmployerContribution () {
    return this.hsaContributionSummary.projectedAnnualEmployerContribution(this.forecastYear);
  }

  get projectedEmployeePayrollContributions () {
    const result = this.hsaContributionSummary.projectedEmployeePayrollContributions(this.forecastYear);
    return _.round(result, 2);
  }

  get projectedPersonalContributions () {
    return this.hsaContributionSummary.projectedPersonalContributions(this.forecastYear);
  }

  get projectedPersonalContributionAdjusted () {
    return Math.max(this.projectedPersonalContributions - this.originalValueAmount, 0);
  }

  get otherHsaContribution () {
    return this.hsaContributionSummary.otherHsaAmount(this.forecastYear);
  }

  get bankDirectContribution () {
    const result = this.hsaContributionSummary.bankDirectContributions(this.forecastYear);
    return _.round(result, 2);
  }

  get activePayrollYear (): number {
    return this.currentMoment().year();
  }

  // centralize all calls to the current time here
  // so that it's easy to test the code with different date times
  currentMoment (): moment.Moment {
    return moment();
  }

  beforeDestroy () {
    window.clearInterval(this.intervalId);
  }

  mounted (): void {
    this.intervalId = window.setInterval(() => this.updateHours(), 5000);
    this.updateHours();

    this.employerBankSettings.getEmployerBankSettingsForCurrentUser();

    if (this.id) {
      this.personalContributionScheduleStore.getContributionSchedule(this.id);
    }

    if (this.isReadyToInitialize) {
      this.onReadyToInitialize();
    }

    if (this.defaultRecurring) {
       this.isOneTimeContribution = false;
    }

    if (this.defaultPriorYear && !this.disableTaxYearSelector) {
       this.isPriorYearContribution = true;
    }

    this.hsabAccountsStore.getHsabAccounts();
    this.hsaContributionSummary.load(this.activePayrollYear);
    this.bankAccountStore.loadLinkedBankAccounts();
    this.hsaLimitStore.getHsaAccountLimits();
    this.hsaTotalStore.getUserPayrollSummary();
    this.hsaStore.loadTransactionTotals({ year: this.currentMoment().year() });
    this.hsaStore.loadTransactionTotals({ year: this.priorYear });
    this.contributionStore.getPriorYearContributionEligibilityStatus();
    this.bankAccountStore.getPriorYearContributionCutoffDate();
    this.bankHolidayStore.loadBankHolidays(this.activePayrollYear);
    // this.bankHolidayStore.loadBankHolidays(this.activePayrollYear + 1);
    this.$validator.extend("isWeekday", transferScheduleUtility.validationObjects.isWeekday);
    this.$validator.extend("isNotFederalHoliday", transferScheduleUtility.validationObjects.isNotFederalHoliday);
    this.$validator.extend("validateDateIsAfter", transferScheduleUtility.validationObjects.validateDateIsAfter);
  }

  get areHolidaysLoaded (): boolean {
    return this.bankHolidayStore.bankHolidaysInYearLoaded(this.activePayrollYear);
    // && this.bankHolidayStore.bankHolidaysInYearLoaded(this.activePayrollYear + 1);
  }

  get defaultPersonalContributionSchedule (): TransferSchedule {
    return {
      scheduleId: 0,
      linkedExternalBankAccountId: 0,
      scheduleType: TransferScheduleType.OneTime,
      scheduleInterval: 1,
      amount: 0,
      scheduleStartDate: this.firstValidStartDate.format("MM/DD/YYYY"),
      scheduleEndDate: null,
      dateLastModified: this.currentMoment().format("MM/DD/YYYY"),
      status: this.setDefaultTransferScheduleStatus,
      userConfirmationDate: null,
      weeklyDetails: [],
      monthlyByDateDetails: [],
      monthlyByDayDetails: [],
      oneTimeDetails: [{isPriorYearContribution: false}],
      isLocked: false
    };
  }

  get setDefaultTransferScheduleStatus () {
    if (!this.hsabAccountsStore.userHasActiveHsaAccounts && this.featureFlagStore.flags.bend30439UpfrontContributions) {
        return TransferScheduleStatus.AwaitingAccountActivation;
    }

    return TransferScheduleStatus.Active;
  }

  get isEditing () {
    return this.formModel && !!this.formModel.scheduleId;
  }
  // editing a scheduled amount moves it to "scheduled" in the donut, along with "personal" along with other contributions.
  // this logic is used to offset it so it doesn't double count the contribution when being edited. nNw schedules are not in personal
  get originalValueAmount () {
    if (this.isEditing) {
      if (this.isOneTimeContribution) {
        return this.personalContributionScheduleStore.schedule.amount;
      }
      else {
        // beware the name here... proposedPersonalContributionScheduleCalendarsForYear
        // this returns the list of upcoming dates within the loaded contribution schedule (contrained to the year supplied)
        const numSchedulesForYear = this.personalContributionScheduleStore.proposedPersonalContributionScheduleCalendarsForYear(this.forecastYear).length;
        return this.personalContributionScheduleStore.schedule.amount * numSchedulesForYear;
      }
    }
    return 0;
  }

  get isReadyToInitialize (): boolean {
    return this.id
      ? (this.personalContributionScheduleStore.isScheduleLoaded && this.areHolidaysLoaded)
      : this.areHolidaysLoaded;
  }

  @Watch("isReadyToInitialize")
  onReadyToInitialize () {
    if (this.isReadyToInitialize) {
      if (this.id) {
      // configure for edit mode
      this.formModel = _.cloneDeep(this.personalContributionScheduleStore.schedule);
    } else {
      // configure for new mode
      this.formModel = _.cloneDeep(this.defaultPersonalContributionSchedule);
    }
    }
  }

  updateHours () {
    const hours = this.currentMoment().clone().tz("America/Chicago").hours();

    if (this.currentHours === hours) {
      return;
    }

    this.currentHours = hours;
  }

  get showScheduleNotFound (): boolean {
    return this.id && this.personalContributionScheduleStore.isScheduleNotFound;
  }

  get isUpfrontContribution () {
    return !this.hsabAccountsStore.userHasActiveHsaAccounts;
  }

  get firstValidStartDate (): moment.Moment {
    // before 2pm Central, contributions for T+1
    // after 2pm Central, contributions for T+2
    const currentCt = this.currentMoment().clone().tz("America/Chicago");

    const result = this.isUpfrontContribution || this.currentHours > 13 || !isBusinessDay(this.federalHolidays, currentCt)
      ? addBusinessDays(this.federalHolidays, currentCt, 2)
      : addBusinessDays(this.federalHolidays, currentCt, 1);
    return moment(result);
  }

  get isEditingDisabled (): boolean {
    return !!this.id && this.personalContributionScheduleStore.schedule.isLocked;
  }

  get disableBeforeDateInclusive (): string {
    return this.firstValidStartDate.clone().add(-1, "days").format("MM/DD/YYYY");
  }

  get startDateValidation () {
    return {
      required: true,
      isWeekday: true,
      isNotFederalHoliday: this.federalHolidays,
      validateDateIsAfter: this.firstValidStartDate.format("MM/DD/YYYY")
    };
  }

  get isPriorYearContribution () {
    return this.formModel && this.isOneTimeContribution
      && this.formModel.oneTimeDetails && !!this.formModel.oneTimeDetails.find(item => item.isPriorYearContribution);
  }

  set isPriorYearContribution (value) {
    const pyc = this.isOneTimeContribution && !!value;

    this.formModel.oneTimeDetails = [{isPriorYearContribution: pyc}];
  }

  @Watch("formModel.scheduleStartDate")
  onStartDateChange (startDate) {
    if (startDate === null) {
      return;
    }

    this.updateProjectedContributions();

    const proposedForecastYear = this.isOneTimeContribution && this.isPriorYearContribution ?
      this.priorYear : moment(this.formModel.scheduleStartDate).year();

    this.setForecastYearWhenValid(proposedForecastYear);
  }

  setForecastYearWhenValid (proposedForecastYear: number) {
    const currentYear = this.currentMoment().year();
    if (!this.isPriorYearContribution &&
        proposedForecastYear >= currentYear &&
        proposedForecastYear <= (currentYear + 1)) {
      this.forecastYear = proposedForecastYear;
    }

    if (this.isPriorYearContribution && proposedForecastYear === currentYear - 1) {
      this.forecastYear = proposedForecastYear;
    }
  }

  @Watch("formModel", { deep: true })
  updateScheduleDescription () {
    this.description = transferScheduleUtility.getScheduleDescription(this.formModel);
  }

  @Watch("formModel", { deep: true })
  updateProjectedContributions () {
      if (this.isOneTimeContribution || this.isMissingOptions) {
        return;
      }

      // the project contributions are irrelevant if there is not an amount
      // data is invalid if not at least one penny per contribution.
      if (this.formModel.amount < 0.01) {
        return;
      }

    const endDate = this.formModel.scheduleEndDate ?
        moment(this.formModel.scheduleEndDate).format("YYYY-MM-DD")
        : `${this.activePayrollYear + 1}-12-31`;

    const formData = _.cloneDeep(this.formModel);
    // Force the date string to a format accepted by the server model binding, prevents exceptions.
    formData.scheduleStartDate = moment(formData.scheduleStartDate).format("YYYY-MM-DD");
    formData.scheduleEndDate = formData.scheduleEndDate ? moment(formData.scheduleEndDate).format("YYYY-MM-DD") : null;

    const args = {
      proposedSchedule: formData,
      toDate: endDate,
      numberOfCalendarEntries: 3
    };

    this.debouncedGetProposedScheduleCalendars(args);
  }

  get isOneTimeContribution () {
    return this.formModel && this.formModel.scheduleType === TransferScheduleType.OneTime;
  }

  set isOneTimeContribution (value: boolean) {
    if (!this.isEditing) {
      if (value) {
        this.oldScheduleType = this.formModel.scheduleType;
        this.formModel.scheduleType = TransferScheduleType.OneTime;
      } else {
        this.formModel.scheduleType = this.oldScheduleType || TransferScheduleType.Weekly;
      }
    }
  }

  // the component ScheduleFrequencySelect input/out slightly mismatches our form model, perform conversion
  get contributionFrequencySelection (): RecurringSchedule {
    const contributionSchedule: RecurringSchedule = {
      ...transferScheduleUtility.defaultValues.everyWeekRecurringSchedule,
      scheduleType: this.formModel.scheduleType,
      scheduleInterval: this.formModel.scheduleInterval
    };

    switch (this.formModel.scheduleType) {
      case (TransferScheduleType.Weekly):
        contributionSchedule.days = this.formModel.weeklyDetails.map(details => details.dayOfWeek);
        break;

      case (TransferScheduleType.MonthlyByDay):
        contributionSchedule.dayOfWeek = this.formModel.monthlyByDayDetails[0].dayOfWeek;
        contributionSchedule.scheduleMonthBoundary = this.formModel.monthlyByDayDetails[0].monthBoundary;
        break;

      case (TransferScheduleType.MonthlyByDate):
        contributionSchedule.dates = this.formModel.monthlyByDateDetails.map(details => {
          return details.isLastDay ? "Last" : details.dayOfMonth.toString();
        });
        break;

      default:
        break;
    }

    return contributionSchedule;
  }

  // the component ScheduleFrequencySelect input/out slightly mismatches our form model, perform conversion
  set contributionFrequencySelection (value: RecurringSchedule) {
      const monthlyByDayDetails: TransferScheduleMonthlyByDayDetails[] = [
      {
        monthBoundary: value.scheduleMonthBoundary,
        dayOfWeek: value.dayOfWeek
      }
    ];
    switch (value.scheduleType) {
      case (TransferScheduleType.Weekly):
        this.formModel.weeklyDetails = value.days.map(weekday => ({
          dayOfWeek: weekday
        }));
        break;

      case (TransferScheduleType.MonthlyByDay):
        this.formModel.monthlyByDayDetails = _.cloneDeep(monthlyByDayDetails);
        break;

      case (TransferScheduleType.MonthlyByDate):
        this.formModel.monthlyByDateDetails = value.dates.map(date => ({
          dayOfMonth: date === "Last" ? null : +date,
          isLastDay: date === "Last" ? true : false
        }));

        break;
    }
    this.formModel.scheduleInterval = value.scheduleInterval;
    this.formModel.scheduleType = value.scheduleType;
  }

  @Watch("isPriorYearContribution")
  onPriorYearChange (isPriorYear) {
    this.setForecastYearWhenValid(isPriorYear ? this.priorYear : this.activePayrollYear);
  }

  get isMissingOptions () {
    return (this.formModel.scheduleType === TransferScheduleType.Weekly && this.formModel.weeklyDetails.length < 1)
    || (this.formModel.scheduleType === TransferScheduleType.MonthlyByDay && this.formModel.monthlyByDayDetails.length < 1)
    || (this.formModel.scheduleType === TransferScheduleType.MonthlyByDate && this.formModel.monthlyByDateDetails.length < 1);
  }

  onCancel (): void {
    this.$router.push({ name: Contribution });
  }

  onSkip () {
    this.$emit("skip");
  }

  onSubmit (): void {
    if (this.isSubmitting) {
      return;
    }

    if (this.isMissingOptions) {
      return;
    }

    this.$validator.validateAll()
        .then(isValid => {
          if (!isValid) {
            return;
          }

          const selectedDate = moment(this.formModel.scheduleStartDate);
          // Handle edge case if user opens page before 2PM CT and submits contribution for
          // T+1 after 2PM CT. Don't enforce this if user is editing existing schedule since start date can be earlier
          if (!this.isEditing && moment(selectedDate).isBefore(this.firstValidStartDate.date())) {
            if (this.isOneTimeContribution) {
              this.notifierStore.setDanger("Must select later post date");
            }
            else {
              this.notifierStore.setDanger("Must select later start date");
            }
            return;
          }

          if (this.isOneTimeContribution) {
            // User cannot schedule one-time contribution on weekend or bank holiday
            // bank holiday validation is performed on backend
            if (selectedDate.day() === 0 || selectedDate.day() === 6) {
              this.notifierStore.setDanger("Must select valid business day");
              return;
            }
          }

          // One time contributions just need the T+C
          // Schedules get sent to an entire new page to view the proposed schedule
          if (this.isOneTimeContribution) {
            this.confirmModalVisible = true;
            this.isSubmitting = true;
          } else {
            this.$router.push(this.routeToConfirmation(this.formModel, this.isEditing));
          }
        });
  }

  onContributionConfirmation () {
    this.formModel.userConfirmationDate = moment.utc().toISOString();
    if (this.isEditing) {
      this.personalContributionScheduleStore.updatePersonalContributionSchedule(this.formModel)
          .then(() => {
            this.notifierStore.setSuccess("Your personal contribution schedule has been updated.");
          })
          .finally(() => {
            this.submitComplete();
          });
    } else {
      this.personalContributionScheduleStore.createPersonalContributionSchedule(this.formModel)
          .then(() => {
            this.notifierStore.setSuccess("Your personal contribution schedule has been created.");
          })
          .finally(() => {
            this.submitComplete();
          });
    }
  }

  submitComplete () {
    this.confirmModalVisible = false;
    this.isSubmitting = false;
    if (this.isOnboarding) {
      this.$router.push({
        name: OnboardingContributionScheduledMessage
      });
    } else {
      this.$router.push({ name: Contribution,
                        query: { tab: "schedules"} });
    }
  }

  onContributionCancellation () {
    this.confirmModalVisible = false;
    this.isSubmitting = false;
  }

  get federalHolidays (): string[] {
    return [...this.bankHolidayStore.bankHolidaysInYear(this.activePayrollYear), ...this.bankHolidayStore.bankHolidaysInYear(this.activePayrollYear  + 1)];
  }

  get contributionTypeOptions (): { text: string, value: string | number, disabled: boolean }[] {
    if (!this.isLoaded) {
      return [];
    }

    const linkedAccounts = this.bankAccountStore.sortedLinkedContributionAccounts("defaultContributionAccountId")
      .map(account => {
        return {
          text: account.bankAccountName + " " + account.bankAccountNumber,
          value: account.linkedBankAccountId,
          disabled: !this.isUpfrontContribution && account.use.status !== LinkedBankAccountUseStatus.Active
        };
      }).filter(x => x.disabled === false);

    if (this.formModel.linkedExternalBankAccountId === 0 && linkedAccounts.length > 0) {
      this.formModel.linkedExternalBankAccountId = linkedAccounts[0].value;
    }

    return linkedAccounts;
  }

  get disableAfterDate (): string {
    return `12/31/${this.activePayrollYear + 1}`;
  }

  get disableTaxYearSelector (): boolean {
    return !this.contributionStore.allowPriorYearContribution || !this.isStartDateBeforeTaxCutoff;
  }

  get isLoaded (): boolean {
    return this.hsaTotalStore.isLoaded
    && this.bankAccountStore.linkedAccountsLoaded
    && !!this.formModel
    && this.employerBankSettings.isLoaded;
  }

  get showFormSelectRadioButtons (): boolean {
    return !this.isEditing && !this.isSubmitting;
  }

  get maxContributionAmount () {
    if (this.isPriorYearContribution) {
      return this.maximumPreviousYearContribution;
    } else {
      const startYear = moment(this.formModel.scheduleStartDate).year();
      return this.hsaContributionSummary.remainingContributionAmount(startYear);
    }
  }

  get validateContributionAmount () {
    return {
      required: true,
      decimal: 2,
      min_value_usd: 0.01,
      max_value_usd: (this.maxContributionAmount + this.originalValueAmount)
    };
  }

  get isStartDateBeforeTaxCutoff () {
    return moment(this.formModel.scheduleStartDate) <= moment(this.bankAccountStore.priorYearContributionsCutoffDate);
  }

  get contributionYearSelectOptions (): { text: string, value: boolean }[] {
    if (this.formModel.scheduleStartDate === null || moment(this.formModel.scheduleStartDate).year() < this.activePayrollYear) {
      return [];
    }

    const selectedYear = moment(this.formModel.scheduleStartDate).year();

    if (this.contributionStore.allowPriorYearContribution && this.isStartDateBeforeTaxCutoff) {
      return [
        {
          text: `${selectedYear}`,
          value: false
        },
        {
          text: `${selectedYear - 1}`,
          value: true
        } ];
    }

    return [
      {
        text: `${selectedYear}`,
        value: false
      } ];
  }

  get maximumPreviousYearContribution (): number {
    return this.hsaContributionSummary.remainingContributionAmount(this.priorYear);
  }

  // Return the years in which we are showing a forecast
  get allowedForecastYears (): number[] {
    if (this.isOneTimeContribution) {
      return this.isPriorYearContribution ? [this.priorYear] : [moment(this.formModel.scheduleStartDate).year()];
    }

    const startDate = Math.max(this.activePayrollYear, moment(this.formModel.scheduleStartDate).year());

    // If the schedule extends into next year, allow it to be shown in the forecast
    let endDate = this.activePayrollYear + 1;
    if (this.formModel.scheduleEndDate) {
      endDate = Math.min(endDate, moment(this.formModel.scheduleEndDate).year());
    }

    return _.range(startDate, endDate + 1);
  }

  updateForecastYear (year: number) {
    this.forecastYear = year;
  }

  get forecastAmount (): number {
    if (this.isOneTimeContribution) {
      return this.formModel.amount;
    }

    const contributions = this.personalContributionScheduleStore
      .proposedPersonalContributionScheduleCalendarsForYear(this.forecastYear);
    const totalAmount = contributions.reduce((sum, contribution) => sum + contribution.amount, 0);
    return _.round(totalAmount, 2);
  }

  get submitButtonText (): string {
    return this.isOneTimeContribution ? "Submit" : "Next";
  }

  get contributionType (): string {
    return this.isOneTimeContribution ? "one-time" : "recurring";
  }

  get isSubmitEnabled () {
    return !(this.isSubmitting || this.$validator.errors.any() || this.isEditingDisabled || this.contributionTypeOptions.length === 0);
  }

  get showRetailContributionsDisclaimer () {
    return this.employerBankSettings.displayRetailContributionDisclaimer;
  }

  get hideLinkNewAccountLink () {
    return this.isOnboarding;
  }
}
